import apiFetch from "api/apiFetch"
import { CustomerEstimate } from "api/types/CustomerEstimate"

const getCustomerEstimate = (estimateKey: string): Promise<CustomerEstimate> => {

    return apiFetch(`api/mpvi/estimate/${estimateKey}`)

}

export default getCustomerEstimate